import React from 'react'

import { NotificationTypeIcon } from '../NotificationTypeIcon'

import { Header, HeaderTitle } from './InboxPreview.styles'

interface InboxPreviewHeaderProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  title: React.ReactNode
}

export const InboxPreviewHeader = ({
  icon,
  title,
}: InboxPreviewHeaderProps) => (
  <Header>
    <NotificationTypeIcon icon={icon} size="md" />
    <HeaderTitle>{title}</HeaderTitle>
  </Header>
)
